import { cloneDeep } from 'lodash';
import { useState } from 'react';

import { AccountTaxTypeGroup, PolicyItem } from '@ndvr/portfolio-api';

export const useAssetLocationEdit = (policyItems?: PolicyItem[]) => {
    const [isEditMode, setIsEditMode] = useState(false);
    const [editablePolicies, setEditablePolicies] = useState<PolicyItem[]>([]);

    const handleEditClick = () => {
        setEditablePolicies(cloneDeep(policyItems) || []);
        setIsEditMode(true);
    };

    const handlePolicyReorder = (policyIndex: number, newOrder: AccountTaxTypeGroup[]) => {
        const newPolicies = [...editablePolicies];
        newPolicies[policyIndex] = {
            ...newPolicies[policyIndex],
            policy: newOrder,
        };
        setEditablePolicies(newPolicies);
    };

    const exitEditMode = () => {
        setEditablePolicies([]);
        setIsEditMode(false);
    };

    return {
        isEditMode,
        editablePolicies,
        handleEditClick,
        handlePolicyReorder,
        exitEditMode,
    };
};
